export default "__VITE_ASSET__D$ae3oPC__"